<template>
    <div>
        <el-dialog title="选择商品" :visible.sync="visible" width="1200px" :close-on-click-modal="false">
            <el-row style="margin-top: -20px" type="flex" justify="space-between">
                <div></div>
                <el-form size="small" :model="query" inline @submit.native.prevent>
                    <el-form-item>
                        <el-input v-model="query.search_keyword" placeholder="请输入商品标题" clearable @keyup.enter.native="handleSearch"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row :gutter="20" style="min-height: 500px">
                <el-col :span="7">
                    <el-button type="text" style="all-btn" @click="handleAll">全部分类</el-button>
                    <el-tree
                        ref="tree"
                        node-key="uuid"
                        highlight-current
                        :expand-on-click-node="false"
                        :data="categories"
                        :props="defaultProps"
                        @node-click="handleNodeClick"
                    ></el-tree>
                </el-col>
                <el-col :span="17">
                    <ListPage
                        ref="listPage"
                        :search="false"
                        :total="total"
                        v-loading="loading"
                        :data="tableData"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        @search="handleSearch"
                        @reset="resetQuery"
                        @selection-change="handleSelectionChange"
                    >
                        <template slot="columns">
                            <el-table-column type="selection" width="50" align="center"></el-table-column>
                            <el-table-column label="商品名称" align="center" prop="name" />
                            <el-table-column label="商品类别" align="center" prop="category.name" />
                        </template>
                    </ListPage>
                </el-col>
            </el-row>
            <span slot="footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirm">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import listMixin from "@/mixins/list";
import { list as categoryList } from "@/api/product/category";
import { list } from "@/api/product/list";
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            visible: false,
            query: {
                search_keyword: "",
                search_category_uuid: "",
                type: "",
            },
            categories: [],
            defaultProps: {
                children: "children",
                label: "name",
            },
            ids: [],
            ids_d: [],
            picks: [],
            names: [],
        };
    },
    watch: {
        value(val) {
            this.picks = val;
        },
    },
    mixins: [listMixin],
    mounted() {
        this.getCategories(1);
        this.getCategories(2);
    },
    methods: {
        open() {
            this.visible = true;
            this.search();
        },
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            list(params).then(({ code, result, msg }) => {
                if (code === 200) {
                    this.tableData = result.data;
                    this.total = result.total;
                    this.setChecks();
                } else {
                    this.$message.error(msg);
                }
                this.loading = false;
            });
        },
        getCategories(type) {
            categoryList({ page_index: 1, page_size: 9999, type }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.categories.push({ name: type == 1 ? "连接器" : "工具", uuid: type, children: result.data, root: true });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleAll() {
            this.query.search_category_uuid = "";
            this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(null);
            });
            this.search();
        },
        handleNodeClick(data) {
            if (data.root) return;
            this.query.search_category_uuid = data.uuid;
            this.search();
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        merge() {
            this.ids.forEach((x) => {
                if (!this.picks.find((n) => n.uuid == x)) {
                    this.picks.push(this.names.find((n) => n.uuid == x));
                }
            });
            this.ids_d.forEach((x) => {
                if (this.picks.find((n) => n.uuid == x)) {
                    this.picks = this.picks.filter((y) => y.uuid !== x);
                }
            });
        },
        setChecks() {
            this.tableData.map((x) => {
                if (this.picks.find((n) => n.uuid == x.uuid)) {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, true);
                    });
                } else {
                    this.$nextTick(() => {
                        this.$refs.listPage.getTableRef().toggleRowSelection(x, false);
                    });
                }
            });
        },
        handleConfirm() {
            if (this.picks.length === 0) {
                this.$message.warning("请选择商品");
                return;
            }
            this.$emit("pick", JSON.parse(JSON.stringify(this.picks)));
            this.visible = false;
        },
    },
};
</script>

<style lang="less" scoped>
:deep(.el-radio__label) {
    padding-left: 0;
}
.all-btn {
    position: relative;
    top: -20px;
    font-weight: bold;
    color: #333;
}
</style>
